import { useMemo } from 'react';

import { useBestPracticesFiltersQuery } from 'hooks/queries/security-insights';

import { useActiveClusters } from '../../../_hooks';
import {
  NamespaceSelectBase,
  NamespaceSelectBaseProps,
} from '../../_components';
import { useClustersOrFixture } from '../../hooks/useClustersOrFixture';

type Props = Omit<NamespaceSelectBaseProps, 'namespaces' | 'isLoading'> & {
  clusterIds?: string[];
};

export const NamespaceSelect = ({
  clusterIds: scopedClusterIds,
  ...props
}: Props) => {
  const { clusters: _clusters } = useActiveClusters();
  const { clusters } = useClustersOrFixture(_clusters);
  const clusterIds = useMemo(
    () => scopedClusterIds ?? clusters?.map((cluster) => cluster.id) ?? [],
    [scopedClusterIds, clusters]
  );
  const { filters, isLoading } = useBestPracticesFiltersQuery({
    clusterIds,
  });
  return (
    <NamespaceSelectBase
      namespaces={filters?.namespaces || []}
      isLoading={isLoading}
      {...props}
    />
  );
};
